import SoundPopup from 'components/sound-popup';
import { DOScenes, GameType } from 'names/do-names';
import { Container, Sprite } from 'pixi.js';
import Components from 'slotworks/components/components';
import AnimatedSprite from 'slotworks/graphics/animation/animated-sprite';
import { BounceZoomIn } from 'slotworks/graphics/animation/base-animations';
import CanvasManager, { Orientation } from 'slotworks/graphics/canvas/canvas-manager';
import ls from 'slotworks/utils/local-storage';
import Layers from 'slotworks/graphics/layers/layers';
import { AbstractSceneTransition } from 'slotworks/graphics/layers/scene-transitions/abstract-scene-transition';
import { Group, PIXIElement } from 'slotworks/graphics/pixi/group';
import campaignsModel from 'slotworks/integration/revolver/model/campaigns-model';
import soundManager from 'slotworks/sound/sound-manager';
import stateMachine from 'slotworks/state-machine/state-machine';
import Contract from 'slotworks/utils/contract';
import deviceInfo from 'slotworks/utils/device-info';
import Timer from 'slotworks/utils/timer';
import * as TweenJS from 'slotworks/utils/tween';
import GameInit from 'states/game-init';
import GameState from 'slotworks/model/game-state';
import BetModel from 'slotworks/model/bets/bet-model';
import regulation from 'slotworks/integration/revolver/regulations/regulation';
import settingsModel from 'slotworks/model/settings/settings-model';
import { ToggleEvent } from 'slotworks/graphics/elements/flexi-toggle';

export default class GameIntro extends AbstractSceneTransition {
    public static orientationChange: number = 0;
    private title: Sprite;
    private footerContainer: Container;
    private contentContainer: Container;
    private dontShowIntro: boolean;

    public in(): Contract<void> {
        return new Contract(resolve => {
            GameInit.onGameIntro = true;
            this.title = Layers.Prompts.getSprite('title');
            if (!deviceInfo.isDesktop) {
                deviceInfo.onLayoutChange.add(this.onOrientationChange, this);
            }

            this.footerContainer = Group(
                [
                    Layers.Prompts.getText('toggle_text'),
                    Layers.Prompts.getButton('continue').container,
                    Layers.Prompts.getText('continue'),
                    Layers.Prompts?.getButton('showon').container,
                    Layers.Prompts?.getButton('showoff').container
                ],
                'footerContainer'
            );
            Layers.Background.setScene(DOScenes.INTRO).execute();
            const content = Layers.Prompts.container.children.filter(child => child.name != 'footerContainer' && child.name != 'title') as PIXIElement[];

            this.contentContainer = Group(content, 'contentContainer');
            this.contentContainer.alpha = 0;
            this.footerContainer.alpha = 0;
            this.title.alpha = 0;

            const soundNotification = new SoundPopup();
            soundNotification
                .show()
                .then(() => {
                    resolve(null);
                    const showOn = Layers.Prompts.getFlexiToggle('show');
                    showOn.on(ToggleEvent.CHANGE, () => {
                        this.dontShowIntro = !this.dontShowIntro;
                        settingsModel.setShowIntro(!this.dontShowIntro);
                    });
                    if (CanvasManager.orientation !== Orientation.PORTRAIT) {
                        this.playAnimation();
                    } else {
                        this.contentContainer.alpha = 1;
                        this.footerContainer.alpha = 1;
                        this.title.alpha = 1;
                    }
                })
                .execute();
        });
    }

    private onOrientationChange() {
        this.addContinueButtonListener();
        const showOn = Layers.Prompts.getFlexiToggle('show');
        showOn.setValue(this.dontShowIntro);
        showOn.on(ToggleEvent.CHANGE, () => {
            this.dontShowIntro = !this.dontShowIntro;
            settingsModel.setShowIntro(!this.dontShowIntro);
        });
    }

    private addContinueButtonListener() {
        const currentPrompt = Components.prompt['currentPrompt'];
        currentPrompt.continueButton.destroy();
        currentPrompt.continueButton = Layers.Prompts.getFlexiButton('continue');
        currentPrompt.addContinueListener(() => {
            currentPrompt.hide().execute();
            Layers.showAll();
            if (!campaignsModel.isFreespinsActive()) {
                Layers.PromoBetBar.hide();
            }
            stateMachine.currentState.concrete.skip();
            Components.betBar.setBetOptions(BetModel.generateBetOptions());
            Components.betBar.setCurrentWin(0);
            Components.betBar.setBalance(GameState.getCurrentGame().startBalance);
            Components.betMenu.setBalance(GameState.getCurrentGame().startBalance);
        });
    }

    private playAnimation() {
        this.footerContainer.alpha = 1;
        this.title.alpha = 1;
        this.title.position.y = this.title.position.y - 500;
        new TweenJS.Tween(this.title)
            .easing(TweenJS.Easing.Elastic.Out)
            .to({ y: this.title.position.y + 500 }, 650)
            .start();

        this.footerContainer.position.y = this.footerContainer.position.y + 500;

        new TweenJS.Tween(this.contentContainer)
            .delay(450)
            .onStart(() => {
                for (let i = 0; i < this.contentContainer.children.length; i++) {
                    const child = this.contentContainer.children[i];
                    if (child instanceof PIXI.Text) {
                        BounceZoomIn(child, 500, 0).execute();
                    } else if (child instanceof AnimatedSprite) {
                        child.gotoAndPlay(0);
                    }
                }

                Timer.setTimeout(() => {
                    soundManager.customEvent('Wild_Gunshot_1');
                }, 500);
                soundManager.customEvent('symbol_WW_land_5');
            })
            .easing(TweenJS.Easing.Linear.None)
            .to({ alpha: 1 }, 550)
            .start();

        new TweenJS.Tween(this.footerContainer)
            .delay(1000)
            .easing(TweenJS.Easing.Linear.None)
            .to({ y: this.footerContainer.position.y - 500 }, 550)
            .start();
    }

    public out(): Contract<void> {
        return new Contract(resolve => {
            GameInit.onGameIntro = false;
            regulation.gameReady();
            Timer.setTimeout(() => {
                if (GameInit.gameType === GameType.default)
                soundManager.customEvent("start_background_ambience");
            }, 50);
            Layers.Background.setScene(DOScenes.DEFAULT).execute();
            deviceInfo.onLayoutChange.remove(this.onOrientationChange, this);
            resolve(null);
        });
    }
}



// WEBPACK FOOTER //
// ./src/transitions/game-intro.ts